import { Text } from '~components/Typography';

import { Detail, Details } from './styles';

export const ProfileCardDetails = ({
	items,
}: {
	items: {
		label: string;
		value: string;
	}[];
}) => (
	<Details>
		{items.map(({ label, value }) => (
			<Detail key={label}>
				<Text size="S" as="span" color="grey-52-solid" align="left">
					{label}
				</Text>
				<Text size="M" as="span" align="left">
					{value}
				</Text>
			</Detail>
		))}
	</Details>
);
